import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

const NotificationBadge = ({ className = "" }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [unreadCount, setUnreadCount] = useState(0);

  const fetchUnreadCount = async () => {
    if (!user) {
      setUnreadCount(0);
      return;
    }

    try {
      // Try the new unread-count endpoint first
      const response = await api.get('/chat/unread-count');
      setUnreadCount(response.data.unreadCount || 0);
    } catch (error) {
      
      // Fallback to the old method if new endpoint is not available
      try {
        const response = await api.get('/chat/my-chats');
        const chats = response.data.chats || [];
        
        let totalUnread = 0;
        const currentUserId = user.id || user._id;
        
        chats.forEach(chat => {
          const messages = chat.messages || [];
          messages.forEach(message => {
            const senderId = message.sender?._id || message.sender;
            
            // Only count messages from other users
            if (senderId !== currentUserId) {
              // Check if message has readBy array (new system)
              if (message.readBy && Array.isArray(message.readBy)) {
                const hasRead = message.readBy.some(read => 
                  (read.user?._id || read.user) === currentUserId
                );
                if (!hasRead) {
                  totalUnread++;
                }
              } else {
                // Fallback for old messages without readBy tracking
                // For now, don't count old messages to avoid confusion
                // totalUnread++;
              }
            }
          });
        });
        
        setUnreadCount(totalUnread);
      } catch (fallbackError) {
        setUnreadCount(0);
      }
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    
    // Check every 30 seconds
    const interval = setInterval(fetchUnreadCount, 30000);
    
    return () => clearInterval(interval);
  }, [user]);

  // Reset count when user visits chat page
  useEffect(() => {
    if (location.pathname === '/chat' && unreadCount > 0) {
      // Small delay to allow chat page to load and mark messages as read
      setTimeout(() => {
        fetchUnreadCount();
      }, 1000);
    }
  }, [location.pathname, unreadCount]);

  if (!user || unreadCount === 0) {
    return null;
  }

  return (
    <span className={`absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold animate-pulse ${className}`}>
      {unreadCount > 99 ? '99+' : unreadCount}
    </span>
  );
};

export default NotificationBadge;